export const NAVIGATION_MENU_TEST_ID_SUFFIX = '-menu';

export type NavigationMenuTestIdItem = {
    key?: string;
    id?: string;
    label?: string;
};

export const navigationMenuSemanticKey = (item: NavigationMenuTestIdItem | null | undefined): string | null => {
    if (!item) {
        return null;
    }

    const semanticKey = item.key || item.id;
    if (!semanticKey) {
        return null;
    }

    return semanticKey;
};

export const navigationMenuTestId = (item: NavigationMenuTestIdItem | null | undefined): string | null => {
    const semanticKey = navigationMenuSemanticKey(item);
    return semanticKey ? `${semanticKey}${NAVIGATION_MENU_TEST_ID_SUFFIX}` : null;
};
